const Loader = () => {
    const loader = document.querySelector('.loader');
    const body = document.body;

    loader.classList.add('loader-inactive');
    body.classList.remove('loader-active');
}

export{ Loader }